import React, { CSSProperties, useState } from "react";
import { IoMdRadioButtonOn, IoMdRadioButtonOff } from "react-icons/io";
import { Link } from "react-router-dom"; // Import Link from React Router
import Tooltip from "@mui/material/Tooltip";
// import { InfoCircle } from "../../../assets"; // Assuming InfoCircle is imported elsewhere
import {
  LinkTypeContainer,
  LinkType,
  RadioButton,
  RadioLabel,
  RadioLabelContainer,
  DescriptionContainer,
  Description,
} from "../pages/CharityDonation/PaymentLinkTypeHeader/PaymentLinkType.styles";
import { styled } from "styled-components";
import { CheckBoxOff, CheckBoxOn } from "../../public/assets";
// Interface for payment type props
export interface ItemTypeProps {
  label?: string;
  title?: string;
  value: string;
  description?: string;
  infoIcon?: string;
}

// Component props interface
interface Props {
  itemTypes: ItemTypeProps[];
  onTypeChange: (value: string) => void;
  activeType: string;
  style?: CSSProperties;
  center?: boolean;
  textColor?: boolean;
  info?: string;
  hasBorder?: boolean;
}

const RadioButtonComponent: React.FC<Props> = ({
  itemTypes,
  onTypeChange,
  activeType,
  style,
  center,
  textColor,
  info,
  hasBorder,
}) => {
  const [isActive, setIsActive] = useState<string>(activeType);

  const handleRadioButton = (value: string) => {
    setIsActive(value);
    onTypeChange(value);
  };

  return (
    <>
      {itemTypes.map((type, index) => (
        <LinkTypeContainer key={index} style={style} $hasBorder={hasBorder}>
          <LinkType
            $center={center}
            onClick={() => handleRadioButton(type.value)}
          >
            <RadioButton>
              {isActive === type.value ? (
                <img src="/assets/icons/checkboxOn.svg" />
              ) : (
                <img src="/assets/icons/checkboxOff.svg" />
              )}
            </RadioButton>
            <DescriptionContainer>
              <RadioLabelContainer>
                <RadioLabel $textColor={textColor}>{type.label}</RadioLabel>
                {info && (
                  <Tooltip title={type.title} arrow>
                    <img src={type.infoIcon} alt="info" />
                  </Tooltip>
                )}
              </RadioLabelContainer>
              <Description>{type.description}</Description>
            </DescriptionContainer>
          </LinkType>
        </LinkTypeContainer>
      ))}
    </>
  );
};

export default RadioButtonComponent;
